import { render, staticRenderFns } from "./ProductLineConfigHeader.vue?vue&type=template&id=2195c64c&scoped=true&"
import script from "./ProductLineConfigHeader.vue?vue&type=script&lang=js&"
export * from "./ProductLineConfigHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductLineConfigHeader.vue?vue&type=style&index=0&id=2195c64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195c64c",
  null
  
)

export default component.exports